import { THEME_ENUM } from '@/constants';
import { useCallback } from 'react';
import { THEME_ENUM_TV_VIEW_MAP } from '../constants';
import { useTradingViewStore } from '../store';
import { getWidgetOverrides } from '../utils';

export default function useTradingViewTheme() {
  const { tradingViewWidget } = useTradingViewStore();

  const changeTvTheme = useCallback(
    async (theme: THEME_ENUM) => {
      if (tradingViewWidget && tradingViewWidget?.changeTheme) {
        await tradingViewWidget?.changeTheme(THEME_ENUM_TV_VIEW_MAP[theme]);
        const widgetOverrides = getWidgetOverrides({ theme: THEME_ENUM_TV_VIEW_MAP[theme] });
        await tradingViewWidget?.applyOverrides(widgetOverrides.overrides);
      }
    },
    [tradingViewWidget],
  );

  return { changeTvTheme };
}
